import React, { useState } from "react"
import DfbImage from "../ui-kit/dfb_image"
import DfbHeadline from "../ui-kit/dfb_headline"
import { Transformation } from "cloudinary-react"
import Section from "./section"

const MMediaPodcast = (props) => {
  const [showPlayerFrame, setShowPlayerFrame] = useState(false)

  const toggleInPlacePlayer = function (event) {
    setShowPlayerFrame(true)
    event.preventDefault()
    return false
  }

  return (
    <Section baseClass="m-Media" defaultPaddingTop="small" data={props.data}>
      <div className="m-Media-wrapper">
        <div className="m-Media-container">
          <div className="m-Media-content">
            <a
              onClick={toggleInPlacePlayer}
              href={`${process.env.AUDIO_PLAYER_POPUP_URL}${props.data.media_embed_url}`}
              rel="noopener noreferrer"
              className="c-Media c-Media--podcast"
            >
              <div className="c-Media-embed">
                {props.data.image.src && (
                  <DfbImage image={props.data.image} aspect_ratio="16:9">
                    <Transformation
                      crop="fill"
                      gravity="faces:center"
                      width="905"
                      height="509"
                      quality="auto"
                      fetchFormat="auto"
                    />
                  </DfbImage>
                )}
              </div>
              <div className="c-Media-info">
                <div className="c-Media-category">Podcast</div>
                <DfbHeadline
                  headline={props.data.title}
                  headline_level="h4"
                  add_class="c-Media-headline"
                />
              </div>
              {showPlayerFrame && (
                <iframe
                  className="c-Media-inline-podcast-iframe"
                  title="Audio-Player"
                  src={`${process.env.AUDIO_PLAYER_IFRAME_URL}${props.data.media_embed_url}`}
                  allowFullScreen={true}
                  frameBorder="0"
                ></iframe>
              )}
            </a>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MMediaPodcast
